module.exports = __webpack_public_path__ + "static/media/CardExample1.11cc597b.png";